import React, { useEffect } from "react";
import {useNavigate, useParams} from "react-router-dom";
import HirekCard from "../components/cards/HirekCard"
import tovabb from "../assets/media/icons/tovabb nyil.svg"
import { MDBContainer, MDBCol, MDBRow } from 'mdb-react-ui-kit';
import {useSelector} from "react-redux";
import { Helmet } from "react-helmet-async";

const HirekFilterPage = () => {

  const params = useParams();
  const navigate = useNavigate();
  const { articleCategories, filteredArticles } = useSelector(state => state);

  const eventPageName = articleCategories.find(k => k.id === parseInt(params.categoryId))?.name;

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }, []);
  
  return (
    <>
    <Helmet>
      <title>{eventPageName ? eventPageName : 'Hírek'} - A Vértes Agorája</title>
    </Helmet>
    <section className="hirekpage-section" id="hirekpage-section">
      <MDBContainer style={{maxWidth: "1008px"}} className='p-0 hirek-div'>
      <div className="navigate-div" style={{ marginTop: 0 }}>
            <button onClick={() => { navigate('/home')}}>Főoldal</button>
            <img src={tovabb} alt="tovább nyíl"/>
            <button onClick={() => {navigate('/hirek/hirek')}}>Hírek</button>
            <img src={tovabb} alt="tovább nyíl"/>
            <button>{eventPageName}</button>
          </div>
        <div className="hirek-title">
          <h1>{eventPageName}</h1>
        </div>
        <MDBRow className="m-0 hirek-row">
          {filteredArticles.length > 0 ? filteredArticles.map((k,n) => {return (
            <MDBCol md="4" className="hirek-col px-0" key={n}>
              <HirekCard msg={k}/>
            </MDBCol>
          )}) : <span>Még nincs a kategóriához tartozó tartalom!</span>}
          
        </MDBRow>
       
      </MDBContainer>
    </section>
   
    </>
  );
};

export default HirekFilterPage;
